import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionAriaLabel: {
    defaultMessage: 'Request Timeline expander section',
    description: 'Aria label for the expandable request timeline section',
    id: 'iJpsqQ',
  },
  sectionHeaderTitle: {
    defaultMessage: 'Activity Log',
    id: 'pBA2rq',
    description: 'Expander title for the request timeline section',
  },
  timeRecordAuthorText: {
    defaultMessage: 'Created by {author}',
    description: 'Text describing the author of a timeline entry',
    id: 'NFZ3wE',
  },
});
